// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.h9cCz4,.BD9eME{display:flex;width:100%;height:100%}.h9cCz4{display:flex;flex-direction:column;min-width:450px;max-width:660px}.BD9eME{justify-content:center;align-items:center}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `h9cCz4`,
	"loaderWrapper": `BD9eME`
};
export default ___CSS_LOADER_EXPORT___;
